exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Oval {\n  border-radius: 50%; }\n", ""]);

// exports
